module.exports = __webpack_public_path__ + "static/media/logo138x75white.0db0d0e0.png";